import { formatNumber } from "../../utilities/helpers";

import Table from "react-bootstrap/Table";
import Card from "react-bootstrap/Card";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";

export default function ReportSummary({
  data,
  eventSelected,
  eventDate,
  eventForcast,
  refreshReport,
}) {
  return (
    <Card body className="card--md card-with-border">
      <Stack
        direction="horizontal"
        gap={4}
        className="justify-content-between mb-3"
      >
        {eventForcast && (
          <Stack direction="horizontal" gap={3}>
            <img
              src={`https:${eventForcast?.condition?.icon}`}
              alt={eventForcast?.condition?.text || "Weather forecast icon"}
              width="51"
              height="51"
            />
            <Stack>
              <span className="normal normal-bold">Weather Forecast </span>
              <span className="text-muted small">
                {parseInt(eventForcast?.temp_f)}° |{" "}
                {eventForcast?.condition?.text}
              </span>
            </Stack>
          </Stack>
        )}
        <Button
          variant="outline-light"
          size="sm"
          className="icon-button-sm btn-refresh ms-auto"
          onClick={refreshReport}
        >
          Refresh report
        </Button>
      </Stack>
      <Card body className="card--light card--md card-with-border">
        <Table>
          <thead>
            <tr>
              <th>Source/Type</th>
              <th>Quantity</th>
              <th>Scanned</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Online - (blocktickets.xyz)</td>
              <td>{formatNumber(data?.onlineTicketQty)}</td>
              <td>{formatNumber(data?.onlineTicketsScanned)}</td>
            </tr>
            <tr>
              <td>Box Office</td>
              <td>{formatNumber(data?.boxOfficeTicketQty)}</td>
              <td>{formatNumber(data?.boxOfficeTicketsScanned)}</td>
            </tr>
            <tr>
              <td>Box Office - Complimentary</td>
              <td>{formatNumber(data?.compBoxOfficeTicketQty)}</td>
              <td>{formatNumber(data?.compBoxOfficeTicketsScanned)}</td>
            </tr>
            <tr>
              <td>Assigned - Individual (&lt;20 Tickets)</td>
              <td>{formatNumber(data?.assignedIndividualTicketQty)}</td>
              <td>{formatNumber(data?.assignedIndividualTicketsScanned)}</td>
            </tr>
            <tr>
              <td>Assigned Group (+20 Tickets)</td>
              <td>{formatNumber(data?.assignedGroupTicketQty)}</td>
              <td>{formatNumber(data?.assignedGroupTicketsScanned)}</td>
            </tr>
            <tr>
              <td>Assigned - Complimentary</td>
              <td>{formatNumber(data?.assignedCompTicketQty)}</td>
              <td>{formatNumber(data?.assignedCompTicketsScanned)}</td>
            </tr>
            <tr>
              <td>Packages</td>
              <td>{formatNumber(data?.packagesTicketQty)}</td>
              <td>{formatNumber(data?.packagesTicketsScanned)}</td>
            </tr>
            <tr className="total-row">
              <td>Total</td>
              <td>
                {formatNumber(
                  data?.onlineTicketQty +
                    data?.boxOfficeTicketQty +
                    data?.compBoxOfficeTicketQty +
                    data?.assignedIndividualTicketQty +
                    data?.assignedGroupTicketQty +
                    data?.assignedCompTicketQty +
                    data?.packagesTicketQty,
                )}
              </td>
              <td>{formatNumber(data?.totalScanned)}</td>
            </tr>
          </tbody>
        </Table>
      </Card>
    </Card>
  );
}
